import { Link, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface NavigationInternalLinkProps {
    url: string | undefined;
    label: string | undefined;
    closeNav?: () => void;
}

export default function NavigationInternalLink({ url, label, closeNav }: NavigationInternalLinkProps) {
    const navigate = useNavigate();
    
    if (!url || !label) {
        return null;
    }

    const handleClick = () => {
        if (closeNav) {
            closeNav();
        }
        
        navigate(url);
    };

    return (
        <StyledTypography component={ Link }
            variant="body2"
            onClick={ handleClick }
        >
            { label }
        </StyledTypography>
    );
}

const StyledTypography = styled(Typography)(({ theme }) => ({
    textDecoration: 'none',
    color: theme.palette.text.primary,
    cursor: 'pointer'
})) as typeof Typography;
